 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"ea16275a5bb6a17ede8a92c6c631f4299e6b3204","3":"a35c3806917add7301c890d4be7c057d3f684614","4":"3c71bb633e6d820fbc022956ba84507f4f7ef4af","5":"45b8fa8f769eeaf30dce263ad16a43012959eb36","6":"8cb571fb712555b5543ea31367cbc028f1f27102","7":"b09b495f129397ad93099bc92dc172adf397a53f","8":"ec3aa6a519f8ce748759aa8a4d73cc0e09118a31","9":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","10":"fd113b4cd44afc312952b5152606df4c80fa1a9f","13":"7d59d357","15":"b778622a","16":"component---src-pages-404-jsx","17":"component---src-pages-about-jsx","18":"component---src-pages-accessibility-index-jsx","19":"component---src-pages-accessibility-statement-jsx","20":"component---src-pages-accolades-jsx","21":"component---src-pages-alternative-index-jsx","22":"component---src-pages-black-friday-dear-manager-jsx","23":"component---src-pages-black-friday-index-jsx","24":"component---src-pages-calculator-jsx","25":"component---src-pages-case-studies-jsx","26":"component---src-pages-cheatsheets-jsx","27":"component---src-pages-color-contrast-jsx","28":"component---src-pages-css-3-d-transform-examples-index-jsx","29":"component---src-pages-css-specificity-calculator-jsx","30":"component---src-pages-dear-manager-jsx","31":"component---src-pages-disclaimer-jsx","32":"component---src-pages-docs-changelog-jsx","33":"component---src-pages-docs-faq-jsx","34":"component---src-pages-docs-index-jsx","35":"component---src-pages-download-jsx","36":"component---src-pages-experimental-web-platform-features-jsx","37":"component---src-pages-exported-panes-jsx","38":"component---src-pages-for-llms-jsx","39":"component---src-pages-form-inspector-index-jsx","40":"component---src-pages-github-students-jsx","41":"component---src-pages-index-jsx","42":"component---src-pages-integrations-beinclusive-jsx","43":"component---src-pages-integrations-index-jsx","44":"component---src-pages-integrations-jetbrains-webstorm-jsx","45":"component---src-pages-integrations-markerio-jsx","46":"component---src-pages-integrations-toybox-systems-jsx","47":"component---src-pages-integrations-tumult-hype-jsx","48":"component---src-pages-integrations-tumult-whisk-jsx","49":"component---src-pages-legal-jsx","50":"component---src-pages-newsletter-jsx","51":"component---src-pages-opener-jsx","52":"component---src-pages-portal-index-jsx","53":"component---src-pages-pricing-index-jsx","54":"component---src-pages-pricing-quote-jsx","55":"component---src-pages-privacy-jsx","56":"component---src-pages-product-tour-jsx","57":"component---src-pages-quality-assurance-index-jsx","58":"component---src-pages-resources-jsx","59":"component---src-pages-responsive-website-test-jsx","60":"component---src-pages-screenshot-comparison-jsx","61":"component---src-pages-site-quality-index-jsx","62":"component---src-pages-snippets-index-jsx","63":"component---src-pages-social-media-previews-index-jsx","64":"component---src-pages-special-offers-jsx","65":"component---src-pages-support-index-jsx","66":"component---src-pages-syntax-jsx","67":"component---src-pages-tailwindcss-jsx","68":"component---src-pages-testimonials-jsx","69":"component---src-pages-thanks-jsx","70":"component---src-templates-blog-list-jsx","71":"component---src-templates-doc-jsx","72":"component---src-templates-post-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"45a21ccfca376fa4c81a","2":"f58d704f460d70e53ec7","3":"30603753ae1a4813dbea","4":"25d2e90ebcd3502c41a6","5":"e1f118a2bce4a451eb04","6":"340b69dec17336d9e8e7","7":"e3a3f4a7573b5ee59591","8":"376c9cce7a506d862de8","9":"d7a8134d6c05ab6d4c48","10":"7523c9447def965b164d","12":"372303cc31e8b4dcee56","13":"d7f4fb53703f0e071e77","15":"4fccd84bb5b47a7dbdf9","16":"c2b0a58964e54938a8e0","17":"ed1dff1ef3f52bf1a527","18":"7e7aa7a688d76baef107","19":"51642f7d746e5f3c66ee","20":"827b490c69ba5a65ce46","21":"3c5e2fc4fbda753f26d1","22":"99469572cdcb4b998a07","23":"fa816988e413371134fe","24":"ed16257dce2bb921bb42","25":"74fc78fa014581e50f86","26":"b3b9e353473a7046cf60","27":"cd0ce965596766057274","28":"2260efd790d9b3992287","29":"669142d5437584050f1f","30":"bfd1924bf330efce5aff","31":"c7a87402406487cad710","32":"45d67fc43cca71257504","33":"26aaaf90bc4c5a282321","34":"41ee280f882cec684a81","35":"4ff9e8e92ba1dd7bb59a","36":"a83745115472b26001bd","37":"d45d91acde58ad9876c3","38":"c72f36f4ade8fb261d53","39":"65d4facbf5670236ec47","40":"0800b353b64a837f6387","41":"5b3806ecf0bea195c46f","42":"20c78ed548e11de7a9e4","43":"86a1e9586f525a2574ee","44":"4dbff7170ae25a36bf3d","45":"6598513a0eebfd100f09","46":"f01ca5326cfb4fb31b57","47":"07a8e0c3e0432acc8cb1","48":"0542c6d66627706c0c0a","49":"676268a697cf7acbde3a","50":"b3f702d779ada127e214","51":"e10a42e61962ccbac88c","52":"b084ecbd37d5bc70884b","53":"57e2d157128fdced4c3e","54":"3b5036872467e1872133","55":"cf708e4841e4d6343ad1","56":"38558282c3e6d3d2cc1c","57":"ae97928aeefe1b1fc58d","58":"e930f25c560eb68456d2","59":"5cb043829370184d0334","60":"ca9220485eb668b4645c","61":"ba6bc09de45df8dca364","62":"4421e0ccfd72cc8e17bc","63":"4e904743f950c0f67d3a","64":"fd8dd31447c77b83df18","65":"1d0ad684b523a03bc650","66":"e03cfa16287525ecebf6","67":"9b5af6519fd8bdb62bc2","68":"2cdba138a5bddd22d509","69":"da507ed0200c38d35490","70":"178c6f3acd27c3d64136","71":"55acc144f9616e8e73d0","72":"089b0fbc7108319b05f3","75":"0c41ea6b65f13ccbfc6d","76":"03c289e73e2c8efb1e01","77":"9ef80fff0d19439472fc","78":"bbe6a900609cd3f7cdde","79":"32d86680c250a794b60a","80":"e3aef228fb6054eafbc9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"ea16275a5bb6a17ede8a92c6c631f4299e6b3204","3":"a35c3806917add7301c890d4be7c057d3f684614","4":"3c71bb633e6d820fbc022956ba84507f4f7ef4af","5":"45b8fa8f769eeaf30dce263ad16a43012959eb36","6":"8cb571fb712555b5543ea31367cbc028f1f27102","7":"b09b495f129397ad93099bc92dc172adf397a53f","8":"ec3aa6a519f8ce748759aa8a4d73cc0e09118a31","9":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","10":"fd113b4cd44afc312952b5152606df4c80fa1a9f","13":"7d59d357","15":"b778622a","16":"component---src-pages-404-jsx","17":"component---src-pages-about-jsx","18":"component---src-pages-accessibility-index-jsx","19":"component---src-pages-accessibility-statement-jsx","20":"component---src-pages-accolades-jsx","21":"component---src-pages-alternative-index-jsx","22":"component---src-pages-black-friday-dear-manager-jsx","23":"component---src-pages-black-friday-index-jsx","24":"component---src-pages-calculator-jsx","25":"component---src-pages-case-studies-jsx","26":"component---src-pages-cheatsheets-jsx","27":"component---src-pages-color-contrast-jsx","28":"component---src-pages-css-3-d-transform-examples-index-jsx","29":"component---src-pages-css-specificity-calculator-jsx","30":"component---src-pages-dear-manager-jsx","31":"component---src-pages-disclaimer-jsx","32":"component---src-pages-docs-changelog-jsx","33":"component---src-pages-docs-faq-jsx","34":"component---src-pages-docs-index-jsx","35":"component---src-pages-download-jsx","36":"component---src-pages-experimental-web-platform-features-jsx","37":"component---src-pages-exported-panes-jsx","38":"component---src-pages-for-llms-jsx","39":"component---src-pages-form-inspector-index-jsx","40":"component---src-pages-github-students-jsx","41":"component---src-pages-index-jsx","42":"component---src-pages-integrations-beinclusive-jsx","43":"component---src-pages-integrations-index-jsx","44":"component---src-pages-integrations-jetbrains-webstorm-jsx","45":"component---src-pages-integrations-markerio-jsx","46":"component---src-pages-integrations-toybox-systems-jsx","47":"component---src-pages-integrations-tumult-hype-jsx","48":"component---src-pages-integrations-tumult-whisk-jsx","49":"component---src-pages-legal-jsx","50":"component---src-pages-newsletter-jsx","51":"component---src-pages-opener-jsx","52":"component---src-pages-portal-index-jsx","53":"component---src-pages-pricing-index-jsx","54":"component---src-pages-pricing-quote-jsx","55":"component---src-pages-privacy-jsx","56":"component---src-pages-product-tour-jsx","57":"component---src-pages-quality-assurance-index-jsx","58":"component---src-pages-resources-jsx","59":"component---src-pages-responsive-website-test-jsx","60":"component---src-pages-screenshot-comparison-jsx","61":"component---src-pages-site-quality-index-jsx","62":"component---src-pages-snippets-index-jsx","63":"component---src-pages-social-media-previews-index-jsx","64":"component---src-pages-special-offers-jsx","65":"component---src-pages-support-index-jsx","66":"component---src-pages-syntax-jsx","67":"component---src-pages-tailwindcss-jsx","68":"component---src-pages-testimonials-jsx","69":"component---src-pages-thanks-jsx","70":"component---src-templates-blog-list-jsx","71":"component---src-templates-doc-jsx","72":"component---src-templates-post-jsx"}[chunkId]||chunkId) + "." + {"0":"f85f3872dcd680b2a8a2","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
